module.exports = __webpack_public_path__ + "static/media/arrow_front.62031469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_front.png
// module id = 381
// module chunks = 0